<template>
  <div>
    <b-row>
      <h1>Clientes Varejo</h1>
    </b-row>
    <b-row>
      <b-col>
        <b-button variant="primary" size="sm" title="Voltar" class="mr-3" @click="voltar">
          <i class="fas fa-arrow-left"></i> Voltar</b-button>
      </b-col>
    </b-row>
    <b-row class="mt-2 mb-3">
      <b-card class="col-md-11">
        <b-row class="mb-2">
          <b-col class="col-md-6">
            <b-form-input id="buscar" size="sm" placeholder="Buscar" v-model="filter" type="search" />
          </b-col>
        </b-row>
        <b-row>
          <b-table :items="clientes" :busy="isLoading" :fields="header" empty-text="Nenhum cliente encontrado..."
            stacked="xl" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
            :current-page="currentPage" :per-page="perPage" :filter="filter" :filter-included-fields="filterOn"
            @filtered="onFiltered" show-empty small striped hover>
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Carregando ...</strong>
              </div>
            </template>
            <!-- COLUNA EDITAR -->
            <template #cell(editar)="row">
              <b-button size="sm" title="Boletos" variant="primary" @click="showBoletos(row.item)">
                <i class="fa fa-barcode"></i>
              </b-button>
              <b-button v-if="perfil == 'adm' || perfil == 'gerente_varejo'" size="sm"
                title="Alterar Grupo de Desconto e Prazo" variant="success" @click="editar(row.item)">
                <i class="fas fa-hand-holding-usd"></i>
              </b-button>
            </template>
          </b-table>
        </b-row>
        <b-row class="mt-2 mb-1">
          <b-col>
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" size="sm"
              class="my-0"></b-pagination>
          </b-col>
          <b-col class="text-right">
            Total de Clientes: {{ clientes.length }}
          </b-col>
        </b-row>
      </b-card>
    </b-row>

    <!-- Modal de configuração do grupo de desconto e prazo de pagamento -->
    <b-modal size="lg" v-model="modalDesconto">
      <b-card>
        <b-row>
          <b-col class="col-md-4"> Código: </b-col>
          <b-col>
            <b class="text-primary"> {{ selecionado.codigo }}</b>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="col-md-4"> Data de Cadastro: </b-col>
          <b-col>
            <b class="text-primary">{{ selecionado.criacao }} </b>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="col-md-4"> Última Alteração: </b-col>
          <b-col>
            <b class="text-primary">{{ selecionado.editado }}</b>
          </b-col>
        </b-row>

        <b-row class="mt-3" align-v="end">
          <b-col class="col-md-4">
            <label for="grupoDesc">Prazo de Pagamento:</label>
          </b-col>
          <b-col class="col-md-4">
            <b-form-select size="sm" :disabled="perfil !== 'adm' && perfil !== 'gerente_varejo'" v-if="selecionado"
              v-model="selecionado.prazo_pagamento_id" :options="optionsPrazo" />
          </b-col>
        </b-row>


        <b-row class="mt-3" align-v="end">
          <b-col class="col-md-4">
            <label for="grupoDesc">Grupo de Desconto:</label>
          </b-col>
          <b-col>
            <b-form-select size="sm" :disabled="perfil !== 'adm' && perfil !== 'gerente_varejo'" id="grupoDesc"
              v-if="selecionado" v-model="selecionado.grupo_desconto_varejo" :options="options" @change="buscaGrupo" />
          </b-col>
          <b-col>
            <b-button v-if="!mostrar" v-b-toggle.collapse-1 @click="buscaGrupo" variant="secondary" size="sm">
              <b-spinner v-if="loadGrupo" small></b-spinner>
              Mostrar
            </b-button>
            <b-button v-if="mostrar" v-b-toggle.collapse-1 @click="mostrar = false" variant="secondary" size="sm">
              <b-spinner v-if="loadGrupo" small></b-spinner>
              Ocultar
            </b-button>
          </b-col>
        </b-row>
        <b-row class="md-12">
          <b-col class="col-md-12">
            <b-collapse id="collapse-1" class="mt-2 md-10">
              <b-container class="mt-2 md-12" fluid="xl">
                <b-card>
                  <b-row>
                    <b-table :items="grupo" :fields="headerGrupo" striped small>
                    </b-table>
                  </b-row>
                </b-card>
              </b-container>
            </b-collapse>
          </b-col>
        </b-row>
      </b-card>
      <template #modal-title>
        <h6 class="text-primary">
          <b> {{ selecionado.nome }} </b>
        </h6>
      </template>
      <template #modal-footer>
        <b-button v-if="perfil === 'adm' || perfil === 'gerente_varejo'" variant="primary" size="sm" @click="salvar">
          Salvar</b-button>
        <b-button variant="danger" size="sm" @click="modalDesconto = false">Fechar</b-button>
      </template>
    </b-modal>

    <!-- Modal Boletos -->
    <b-modal size="xl" v-model="modalBoletos">
      <b-card>
        <b-row align-v="end">
          <b-col class="md-4">
            <label for="status">Status</label>
            <b-form-select id="status" size="sm" v-model="statusBoleto" :options="listStatus"></b-form-select>
          </b-col>
          <b-col class="md-3">
            <label for="dateD">Vencimento De</label>
            <b-form-datepicker id="dateD" placeholder="Nenhuma Data" calendar-width="200" label-no-date-selected=""
              label-next-month="Próximo Mês" label-next-year="Próximo Ano" label-prev-month="Mês Anterior"
              label-prev-year="Ano Anterior" label-current-month="Mês Atual" label-help hide-header reset-button
              reset-button-variant="danger" label-reset-button="Limpar" v-model="dataDe" size="sm" :date-format-options="{
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
        }" locale="pt-BR">
            </b-form-datepicker>
          </b-col>
          <b-col class="md-3">
            <label for="dateA">Até</label>
            <b-form-datepicker id="dateA" placeholder="Nenhuma Data" calendar-width="200" label-no-date-selected=""
              label-next-month="Próximo Mês" label-next-year="Próximo Ano" label-prev-month="Mês Anterior"
              label-prev-year="Ano Anterior" label-current-month="Mês Atual" label-help hide-header reset-button
              reset-button-variant="danger" label-reset-button="Limpar" v-model="dataAte" size="sm"
              :date-format-options="{
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
        }" locale="pt-BR">
            </b-form-datepicker>
          </b-col>
          <b-col class="md-2">
            <b-button :disabled="loadBoleto" size="sm" variant="primary" @click="loadBoletos">
              <b-spinner small v-if="loadBoleto"></b-spinner>
              <i class="fas fa-search"></i>
              Buscar
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-table v-if="boletos.length > 0" :items="boletos" :fields="headerBoleto" striped small class="mt-2">
            <template #cell(boleto)="row">
              <b-button v-if="!row.item.BAIXA" size="sm" variant="primary" @click="gerarBoleto(row.item)"><i
                  class="fas fa-file-pdf"></i>
              </b-button>
            </template>
          </b-table>
        </b-row>
      </b-card>
      <template #modal-title>
        <h6 class="text-primary">
          <b>
            {{ clienteSelecionado.codigo + " - " + clienteSelecionado.nome }}
          </b>
        </h6>
      </template>
      <template #modal-footer>
        <b-button size="sm" variant="primary" @click="modalBoletos = false">Fechar</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
export default {
  name: "clientes-venda-direta",

  data() {
    return {
      optionsPrazo: [],
      dataAte: "",
      dataDe: "",
      statusBoleto: "A",
      listStatus: [
        {
          value: "A",
          text: "Abertos",
        },
        {
          value: "B",
          text: "Baixados",
        },
      ],
      clienteSelecionado: {},
      modalBoletos: false,
      modalDesconto: false,
      loadGrupo: false,
      filter: null,
      perfil: null,
      mostrar: false,
      grupo: [],
      filterOn: ["nome", "codigo"],
      totalRows: 1,
      currentPage: 1,
      perPage: 30,
      clientes: [],
      options: [],
      selecionado: {},
      sortBy: "grupo_desconto",
      sortDesc: false,
      sortDirection: "asc",
      isLoading: false,
      headerBoleto: [
        {
          key: "NUNDOC",
          label: "Fatura",
        },
        {
          key: "EMISSAO",
          label: "Emissao",
          formatter: (value) => {
            if (value) {
              return moment(value).format("DD/MM/YY");
            }
          },
          sortable: true,
        },
        {
          key: "VENCREA",
          label: "Vencimento",
          formatter: (value) => {
            if (value) {
              return moment(value).format("DD/MM/YY");
            }
          },
          sortable: true,
        },
        {
          key: "VALORTOTAL",
          label: "Valor",
          sortable: true,
          formatter: (value) => {
            return parseFloat(value).toFixed(2).toString().replace(".", ",");
          },
        },
        {
          key: "BAIXA",
          label: "Dt Baixa",
          formatter: (value) => {
            if (value) {
              return moment(value).format("DD/MM/YY");
            }
          },
          sortable: true,
        },
        {
          key: "boleto",
          label: "Boleto",
        },
      ],
      headerGrupo: [
        {
          key: "quantidade_minima",
          label: "Mínimo",
        },
        {
          key: "quantidade_maxima",
          label: "Máximo",
        },
        {
          key: "valor",
          label: "Desconto",
        },
      ],
      header: [
        {
          key: "codigo",
          class: "text-center",
          label: "Código",
        },
        {
          key: "nome",
          label: "Nome",
          sortable: true,
        },
        {
          key: "grupo_desconto_varejo",
          class: "text-center",
          label: "Grupo de Desconto",
        },
        {
          key: "created_at",
          class: "text-center",
          label: "Cadastro",
          formatter: (value) => {
            return moment(value).format("DD/MM/YYYY");
          },
        },
        {
          key: "editar",
          class: "text-center",
          label: "",
        },
      ],
      boletos: [],
      loadBoleto: false,
    };
  },
  methods: {
    getPrazos() {
      const vm = this;
      vm.loading = true

      let data = {
        currentPage: 1,
      };

      axios.get('/adm/prazo', { params: data })
        .then((response) => {
          vm.optionsPrazo = response.data.map((el) => {
            return  {
                value: el.id,
                text: el.descricao
              }
          })
        }).catch((error) => {
          console.log(error)
        }).finally(() => {
          vm.loading = false
        })
    },
    loadBoletos() {
      const vm = this;
      vm.boletos = [];
      if (vm.dataDe && vm.dataAte && vm.dataDe > vm.dataAte) {
        return vm.$swal({
          title:
            "A data vencimento de, deve ser menor que a data vencimento até!",
          icon: "info",
          focusConfirm: true,
          confirmButtonText: "Ok",
        });
      }
      this.loadBoleto = true;

      let data = {
        from: vm.dataDe, //? vm.dataDe : "",
        to: vm.dataAte, //? vm.dataAte : "",
        novo: true,
        status: vm.statusBoleto,
        distribuidor: vm.clienteSelecionado
          ? vm.clienteSelecionado.codigo
          : null,
      };
      vm.loadingBoletos = true;
      axios
        .get("/boleto/list", {
          params: data,
        })
        .then(function (response) {
          vm.sortDesc = vm.status == "A" ? false : true;
          let BOLETOS = [];
          if (response.data.Boleto) {
            BOLETOS = response.data.Boleto;
          } else {
            BOLETOS = response.data;
          }
          if (BOLETOS) {
            vm.distribuidorBusca =
              BOLETOS.length > 0
                ? BOLETOS[0].CLIENTE + " - " + BOLETOS[0].NOME
                : "";
            BOLETOS.forEach((el) => {
              el.STATUS = el.STATUS == "A" ? "ABERTO" : "BAIXADO";
              el.BAIXA =
                typeof el.BAIXA === "string" ? vm.formataData(el.BAIXA) : "";
              el.EMISSAO = vm.formataData(el.EMISSAO);
              el.VENCREA = vm.formataData(el.VENCREA);
            });
            vm.boletos = BOLETOS;
          }
        })
        .catch(function (error) {
          $(".loading").hide();
          console.log(error);
          if (error.response.status === 422) {
            return vm.$swal({
              icon: "error",
              title: error.response.data.errors,
            });
            //return alert(error.response.data.errors );
          }
          alert("Erro ao carregar os boletos.");
        })
        .finally(() => {
          vm.loadBoleto = false;
        });
    },
    gerarBoleto(data) {
      const vm = this;
      this.loadingBoleto = true;
      let dados = data;
      axios
        .post("/boleto/gerar", { boleto: JSON.stringify(dados) })
        .then(function (resp) {
          if (resp.data == "Dados inválidos") {
            return vm.$swal(
              "Dados inválidos para este boleto",
              "Carteira inválida",
              "error"
            );
          }

          var openBoleto = window.open("", "_blank");
          let objBoleto = resp.data.boleto;
          let html = "";
          html += "<html>";
          html += "<title>" + data.NUNDOC + "</title>";
          html += '<body style="margin:0!important">';
          html +=
            '<embed width="100%" height="100%" src= "data:application/pdf;base64,' +
            objBoleto +
            '" type="application/pdf" />';
          //html += '<embed width="100%" height="100%" src="data:application/pdf;base64,'+ objBoleto +'" />';
          html += "</body>";
          html += "</html>";
          openBoleto.document.write(html);
          //openBoleto.document.write(html);
        })
        .catch(function (error) {
          console.log(error);
          return vm.$swal("Erro ao gerar boleto!", error.message, "error");
        });
    },
    formataData(data) {
      let date = moment(data).format("YYYY-MM-DD");
      return date;
    },
    showBoletos(item) {
      this.boletos = [];
      this.statusBoleto = 'A';
      this.clienteSelecionado = item;
      this.modalBoletos = true;
    },
    buscaGrupo() {
      const vm = this;
      vm.loadGrupo = true;
      vm.grupo = [];
      vm.mostrar = true;
      const data = {
        grupo: vm.selecionado.grupo_desconto_varejo,
      };
      axios
        .post("/venda-direta/descontos/faixas", data)
        .then((response) => {
          if (response) {
            vm.grupo = response.data;
            vm.loadGrupo = false;
          }
        })
        .catch((erro) => {
          vm.loadGrupo = false;
          console.log(erro);
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    voltar() {
      window.location.href = "/venda-direta/";
    },
    loadClientes() {
      const vm = this;
      axios
        .get("/venda-direta/clientes/listar")
        .then((response) => {
          vm.clientes = response.data;
          vm.totalRows = vm.clientes.length;
          vm.clientes.forEach((el) => {
            vm.clientes.criacao = el.created_at;
            if (!el.grupo_desconto_varejo) {
              el.grupo_desconto_varejo = "A";
            }
          });
        })
        .catch((erro) => {
          console.log(erro);
        });
    },

    loadGrupos() {
      const vm = this;
      axios
        .get("/venda-direta/descontos/listarGrupos")
        .then((response) => {
          if (response.data) {
            response.data.forEach((el) => {
              vm.options.push({
                value: el.grupo_desconto,
                text: el.grupo_desconto,
              });
            });
            return vm.options;
          }
        })
        .catch((erro) => {
          console.log(erro);
        });
    },
    editar(cliente) {
      this.selecionado = cliente;
      this.selecionado.criacao = moment(this.selecionado.created_at).format(
        "DD/MM/YYYY"
      );
      this.selecionado.editado = moment(this.selecionado.updated_at).format(
        "DD/MM/YYYY"
      );
      this.mostrar = false;
      this.modalDesconto = true;
    },
    salvar() {
      const vm = this;
      axios
        .post("/venda-direta/clientes/salvar", vm.selecionado)
        .then((response) => {
          if (response.data) {
            vm.modalDesconto = false;
            vm.clientes = [];
            vm.loadClientes();
            vm.$swal(response.data.resposta, "", "success");
          }
        })
        .catch((erro) => {
          console.log(erro);
        });
    },
    getPerfil() {
      const vm = this;
      axios
        .get("/my-profile")
        .then((response) => {
          vm.perfil = response.data.profile.roles[0].name;
        })
        .catch((erro) => {
          console.log(erro);
          alert(erro);
        });
    },
  },
  computed: {},
  mounted() {
    //this.getPerfil();
    this.loadClientes();
    this.loadGrupos();
    this.getPrazos();
    this.perfil = document.getElementById("perfil").value
    //console.log(this.perfil)
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/varejo/distribuidores/index.vue